import { Button, useTheme } from "@cellectenergy/cellect-react-components";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import { ButtonMui } from "@/components/ui";
import dynamic from "next/dynamic";
const ArrowForwardIcon = dynamic(() => import("@mui/icons-material/ArrowForward"), { ssr: false });
import { Box, Typography } from "@mui/material";
import {
  AddressContainer,
  ContactContainer,
  MapContainer,
} from "./ContactAbout.styles";

const ContactAbout = () => {
  const theme = useTheme();
  const { t } = useTranslation("global");

  const mapLink = "https://maps.app.goo.gl/3YbdmRUoD4wfNs6i8";

  return (
    <ContactContainer maxWidth={"1440px"}>
      <AddressContainer>
        <Typography
          variant="display-small"
          color={theme.palette.common.corporateColors.primary.white}
          fontWeight={500}
          sx={{ mb: 2, display: "block" }}
        >
          {t("about.contact.title")}
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Box sx={{ mb: 2 }}>
            <Typography
              sx={{ mb: 0.5, display: "block" }}
              variant="title-large"
              color={theme.palette.common.corporateColors.primary.white}
            >
              {t("about.contact.address1")}
            </Typography>
            <Typography
              sx={{ mb: 0.5, display: "block" }}
              variant="title-large"
              color={theme.palette.common.corporateColors.primary.white}
            >
              {t("about.contact.address2")}
            </Typography>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Link href="tel:+34 931 26 02 11">
              <Typography
                sx={{ mb: 0.5, display: "block" }}
                variant="title-large"
                color={theme.palette.common.corporateColors.primary.white}
              >
                {t("about.contact.phone")}
              </Typography>
            </Link>
            <Link href="mailto:info@cellectenergy.com">
              <Typography
                sx={{ mb: 0.5, display: "block" }}
                variant="title-large"
                color={theme.palette.common.corporateColors.primary.white}
              >
                {t("about.contact.email")}
              </Typography>
            </Link>
          </Box>
        </Box>

        <Link href="/contact">
          <Button
            endIcon={<ArrowForwardIcon fontSize="large" />}
            variant="contained"
            color="secondary"
            sx={{
              mb: 2,
            }}
          >
            {t("about.contact.button1")}
          </Button>
        </Link>
        <Link href={mapLink} target="_blank">
          <Button
            endIcon={<ArrowForwardIcon fontSize="large" />}
            variant="outlined"
            color="secondary"
          >
            {t("about.contact.button2")}
          </Button>
        </Link>
      </AddressContainer>
      <MapContainer>
        <Link href={mapLink} target="_blank">
          <img src="/assets/about/map.webp" alt="map of cellect" />
        </Link>
      </MapContainer>
    </ContactContainer>
  );
};

export default ContactAbout;
